import { toRefs, ref, watch, computed } from 'vue';
import tinycolor from 'tinycolor2';
import kebabCase from 'lodash/kebabCase';
import ChevronIcon from '../../icons/arrows/component-lib.esm2.js';
import CheckIcon from '../../icons/component-lib.esm14.js';
import ErrorIcon from '../../icons/component-lib.esm106.js';
import { useAccordion } from './component-lib.esm5.js';
import { useTheme } from '../../compositions/component-lib.esm7.js';

//
var script = {
  components: {
    ChevronIcon,
    CheckIcon,
    ErrorIcon
  },
  props: {
    value: Boolean,
    disabled: Boolean,
    title: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: null
    }
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      value,
      variant,
      disabled
    } = toRefs(props);
    const root = ref(null);
    const summary = ref(null);
    const content = ref(null);
    const theme = useTheme();
    const {
      isOpen,
      handleClick
    } = useAccordion({
      modelValue: value,
      root,
      summary,
      content,
      disabled
    });
    watch(isOpen, newValue => {
      emit('input', newValue);
    });
    const styles = computed(() => {
      const color = tinycolor(theme.value.colors.primary);
      return {
        '--c-header-active-color': color.setAlpha(0.04).toRgbString()
      };
    });
    const classes = computed(() => {
      return {
        [`v-accordion-item--${kebabCase(variant.value)}`]: variant.value,
        'v-accordion-item--disabled': disabled.value
      };
    });
    return {
      isOpen,
      styles,
      classes,
      root,
      summary,
      content,
      handleClick
    };
  }
};
export { script as default };